import { Api } from "../axios-config";
import { ISetor } from "../setor/SetorService";
import { ITipo } from "../tipo/TipoService";

interface ITipoByCaixa extends ISetor {
    tipos: ITipo[];
}

const trocarEstado = async (idCaixa: number) => {
    try {

        const { data } = await Api.patch(`Caixa/desativar?id=${idCaixa}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao desativar a caixa');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao desativar a caixa');
    }
};

const getTiposByIdCaixa = async (idCaixa: number): Promise<ITipoByCaixa[] | Error> => {
    try {

        const { data } = await Api.get(`Caixa_tipo/pesquisar/tiposPorCaixa?idCaixaStr=${idCaixa}`);;

        if (data) {
            return data
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
};

const apagarArquivos = async (idCaixa: number) => {
    try {

        const { data } = await Api.delete(`Documento/lote?idCaixa=${idCaixa}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao desativar arquivos da caixa');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao desativar arquivos da caixa');
    }
};

export const CaixaService = {
    trocarEstado,
    getTiposByIdCaixa,
    apagarArquivos
}